<template>
  <div class="pages-list">
    <Row>
      <Col :xs="24"
           :sm="12">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入关键词查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
      </Form>
      </Col>
      <Col :xs="24"
           :sm="12">
      <Button @click="showModel()"
              type="success"
              class="f-r">添加</Button>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="page.total"
              :current="page.page"
              :page-size="page.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Drawer :title="title"
            v-model="showModalStatus"
            width="1200"
            :mask-closable="false"
            :styles="styles">
      <div class="pages-create">
        <Form :model="pages"
              ref="activityAdd"
              label-position="right"
              :rules="actValidate"
              :label-width="80"
              action="javascript:void(0)">
          <FormItem label="标题"
                    prop="title">
            <Input v-model="pages.title"
                   placeholder="输入标题..."
                   style="width: 500px"></Input>
          </FormItem>
          <FormItem label="详细">
            <Input v-model="pages.desc"
                   placeholder="输入描述..."
                   type="textarea"
                   style="width: 500px"></Input>
          </FormItem>
          <FormItem label="顶图">
            <upload-thumb v-model="pages.img_url"
                          ref="uploadthumb"
                          :defaultList="thumblist"
                          :autoCropWidth="200"
                          :autoCropHeight="200"
                          tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png、gif,建议图片宽度为200,大小不超过2M</span>"></upload-thumb>
          </FormItem>
          <FormItem label="视频">
            <upload-video v-model="pages.video"
                          ref="uploadVideo"
                          :defaultList="videolist"></upload-video>
          </FormItem>
          <FormItem label="规则说明">
            <UEditor v-model="pages.info"
                     ref="editContent"></UEditor>
          </FormItem>

          <FormItem>
            <!-- <Button>重置</Button> -->
            <Button type="primary"
                    @click="submitAdd('activityAdd')"
                    style="margin-left: 8px">提交</Button>
          </FormItem>
        </Form>
      </div>
    </Drawer>
  </div>
</template>

<script>
import UploadThumb from '../common/thumb'
import UploadVideo from '../common/video'
import UEditor from '../common/ueditor'
export default {
  name: 'pages-list',
  data () {
    return {
      loading: true,
      dataloading: true,
      thumblist: [],
      title: '',
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      page: {
        page: 1,
        size: 10,
        total: 0
      },
      formItem: {
        'key': '',
      },
      list: [
        {
          title: 'Id',
          key: 'id',
          fixed: 'left',
          width: 90
        },
        {
          title: '标题',
          key: 'title',
          width: 200
        },
        {
          title: '描述',
          key: 'desc',
          minWidth: 200,
        },
        {
          title: '操作',
          key: 'action',
          align: 'left',
          width: 150,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.detail(params.index, params.row.id)
                  }
                }
              }, '编辑'),
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.remove(params.index, params.row.id)
                  }
                }
              }, '删除')
            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      actValidate: {
        title: [
          { required: true, message: '标题必须填写', trigger: 'blur', type: 'string' }
        ]
      },
      pages: {
        title: '',
        desc: '',
        info: ''
      },
      positionList: [],
      pagesList: [],
      thumblist: [],
      videolist: [],
      id: '',
    }
  },
  // 组件
  components: {
    UploadThumb,
    UploadVideo,
    UEditor
  },
  created: function () {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function () {
      this.$api.pages.list({ "page": this.page.page, "size": this.page.size }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.page.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 展开添加
    showModel () {
      this.pages = {};
      this.thumblist = [];
      this.videolist = [];
      this.id = 0;
      this.showModalStatus = !this.showModalStatus;
    },
    // 详情
    detail (index, id) {
      this.pages = {};
      this.thumblist = [];
      this.videolist = [];
      this.showModalStatus = !this.showModalStatus;
      this.$api.pages.detail({ id: id }).then(res => {
        if (res.code == 200) {
          this.pages = res.result;
          this.id = id;
          if (this.pages.img_url != null && this.pages.img_url != '') {
            this.thumblist.push({
              name: this.pages.img_url,
              url: this.pages.img_url,
              status: 'finished'
            });
          }
          if (this.pages.video != null && this.pages.video != '') {
            this.videolist.push({
              name: this.pages.video,
              url: this.pages.video,
              status: 'finished'
            });
          }
          let tval = this.pages.text;
          this.$refs['editContent'].message = tval;
        }
      })
    },
    // 删除
    remove: function (index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: '警告',
        content: '<p>此操作不可恢复，三思而后行...</p>',
        onOk: () => {
          this.$api.pages.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.renderTable(1);
            }
          });
        }
      });
    },
    // 翻页
    changePage () {
      this.page.page = this.$refs['listPage'].currentPage;
      this.renderTable(1);
    },
    getPages () {
      this.$api.pages.list({ "page": 1, "size": 999 }).then(res => {
        if (res.code == 200) {
          this.pagesList = res.result.list;
        }
      });
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.page.page = 1;
      }
      this.dataloading = true;
      var ps = { 'key': this.formItem.key, "page": this.page.page, "size": this.page.size };
      this.$api.pages.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.page.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 提交保存
    submitAdd (name) {
      this.$refs[name].validate((valid) => {
        if (!valid) {
          this.$Message.error('请检查输入的信息是否正确！');
          return;
        }
        else {
          if (this.$refs['uploadthumb'].uploadList.length) {
            this.pages.img_url = this.$refs['uploadthumb'].uploadList[0].url;
          } else {
            this.pages.img_url = null;
          }
          if (this.$refs['uploadVideo'].videoList.length) {
            this.pages.video = this.$refs['uploadVideo'].videoList[0].url;
          } else {
            this.pages.video = null;
          }
          this.pages.text = this.$refs['editContent'].message;
          if (this.id == 0) {
            this.$api.pages.create(this.pages).then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.showModalStatus = false;
                this.renderTable(1);
              }
            });
            return;
          } else {
            this.pages.id = this.id;
            this.$api.pages.edit(this.pages).then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.showModalStatus = false;

                this.getTableList();
              }
            });
          }
        }
      })
    },
  },
}
</script>
